// extracted by mini-css-extract-plugin
export default {"goBack__button":"styles_goBack__button__lY0lX","goBack__icon":"styles_goBack__icon__SSnga"};